<script setup>
// Import functions
import { format } from 'quasar'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    required: true,
  },
})

// Quasar Dialog
defineEmits([...useDialogPluginComponent.emits])
const { dialogRef } = useDialogPluginComponent()

// Constants declarations
const { capitalize } = format
const $q = useQuasar()
const attrs = useAttrs()
</script>

<template>
  <q-dialog :maximized="true" ref="dialogRef" no-esc-dismiss no-backdrop-dismiss :class="{ 'mobile-dialog': $q.screen.lt.md }">
    <q-card ref="innerDialog" class="relative-position">
      <div id="products" class="relative-position">
        <q-bar class="bg-primary q-py-lg q-px-md text-h5 text-white">
          <span class="non-selectable text-h6">
            {{ title }}
          </span>
        </q-bar>

        <q-form greedy ref="formValidator" class="relative-position">
          <q-separator />
          <q-card-section class="dialog-maximized scroll q-pa-none relative-position">
            <div class="row">
              <div class="col q-pa-md" v-html="message"></div>
            </div>
          </q-card-section>
        </q-form>
      </div>
    </q-card>
  </q-dialog>
</template>

<style scoped></style>
